import { render } from "./Uploads.vue?vue&type=template&id=2e1bfb06"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"

import "./Uploads.vue?vue&type=style&index=0&id=2e1bfb06&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__